import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Providers } from './app/providers';
import { Router } from './app/router';

import './design-system/tokens.css';
import './design-system/base.css';
import './design-system/components.css';

/**
 * Entry point.
 *
 * StrictMode is on in development, which double-invokes effects - the
 * celestial scene's cleanup and the SEO tag writer are both written to survive
 * that, because an effect that breaks under StrictMode will eventually break
 * under a real remount too.
 */
const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found - index.html is missing #root');
}

createRoot(container).render(
  <StrictMode>
    <Providers>
      <Router />
    </Providers>
  </StrictMode>,
);
